export enum ResponsiveMediaType {
  MOBILE = 0,
  TABLET = 1,
  DESKTOP = 2,
}
